import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('round-caliper', false, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [_createVNode("path", {
    "d": "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M43.9998 24C43.9998 27.3688 43.1489 30.683 41.5259 33.6351C39.903 36.5872 37.5607 39.0815 34.7163 40.8866L30.4297 34.1319C32.1363 33.0489 33.5417 31.5523 34.5155 29.781C35.4892 28.0098 35.9998 26.0213 35.9998 24H43.9998Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M13.4231 40.9745C10.5639 39.193 8.20111 36.7181 6.55386 33.7795C4.90661 30.8409 4.02832 27.5339 4.00049 24.1652L12.0002 24.0991C12.0169 26.1203 12.5439 28.1046 13.5322 29.8677C14.5206 31.6309 15.9383 33.1158 17.6538 34.1847L13.4231 40.9745Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M14.4424 6.43161C17.4016 4.8217 20.7195 3.98536 24.0883 4.00019C27.457 4.01503 30.7674 4.88055 33.7123 6.51646L29.8275 13.5099C28.0605 12.5283 26.0743 12.009 24.053 12.0001C22.0318 11.9912 20.041 12.493 18.2655 13.459L14.4424 6.43161Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});